import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectAccessToken,
  selectAccessTokenExpirationDate,
} from 'shared/store/modules/auth/selectors';

import { useAuth0Session } from 'shared/store/modules/auth/hooks/useAuth0Session';

export function useSession() {
  const { renewSession, isRenewing } = useAuth0Session();

  const accessToken = useSelector(selectAccessToken);
  const accessTokenExpirationDate = useSelector(selectAccessTokenExpirationDate);

  const hasAccessToken = useMemo(() => {
    return Boolean(accessToken);
  }, [accessToken]);

  return {
    hasAccessToken,
    accessTokenExpirationDate,
    isRenewing,
    renewSession
  };
}
